module.exports = __webpack_public_path__ + "img/icon-usp-box.594d0ca3.svg";